import { useEffect, useState } from 'react';
import api, { getUserFacingErrorMessage } from '../utils/api';
import { formatEstateDisplayName } from '../utils/nomineeEstate';

/**
 * Load estates the current nominee can access (with owner display names).
 */
export function useNomineeEstates() {
  const [estates, setEstates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError('');
        const resp = await api.get('/nominee/estates');
        if (cancelled) return;
        setEstates(Array.isArray(resp.data) ? resp.data : []);
      } catch (e) {
        if (cancelled) return;
        setError(getUserFacingErrorMessage(e, {
          fallback: 'We could not load your estates. Please try again.',
          includeSupportForUnknown: false,
        }));
        setEstates([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const labelForOwnerSub = (ownerSub) => {
    const sub = String(ownerSub || '').trim();
    if (!sub) return 'Shared estate';
    const row = estates.find((e) => e?.ownerSub === sub);
    return row ? formatEstateDisplayName(row) : (loading ? 'Loading estate…' : 'Shared estate');
  };

  return { estates, loading, error, labelForOwnerSub };
}
